import { COLORS } from 'constants/colors';
import styled, { css } from 'styled-components';
import { isTouch } from 'utils/isTouch';

const StyledButton = styled.div`
  cursor: pointer;
  padding: 8px 16px;
  border: 2px solid ${({ color }) => color || COLORS.purple};
  border-radius: 50px;
  width: fit-content;
  height: fit-content;
  color: ${({ color }) => color || COLORS.purple};
  background-color: ${({ secondaryColor }) => secondaryColor || COLORS.black};
  display: flex;
  justify-content: center;

  transition: 0.5s;

  ${!isTouch &&
  css`
    &:hover {
      background-color: ${({ color }) => color || COLORS.purple};
      color: ${({ secondaryColor }) => secondaryColor || COLORS.black};
      transform: translate(0px, -5px);
    }
  `}
`;

export const Button = ({ children, onClick, style, color, secondaryColor }) => {
  return (
    <StyledButton
      style={{ ...style }}
      onClick={() => {
        onClick?.();
      }}
      color={color}
      secondaryColor={secondaryColor}
    >
      {children}
    </StyledButton>
  );
};
